export const FORMAT_PERIOD = {
  day: 'dd MMM',
  week: 'wo',
  month: 'LLLL',
}
